<template>
	<article class="req">
		<page-header :title="title" />
		<managing-section header="문의 정보" :column-count="2">
			<managing-box title="문의번호">
				{{ cspId }}
			</managing-box>
			<managing-box title="접수일">
				{{ detail.createdAtReq }}
			</managing-box>
		</managing-section>
		<managing-section :splice="true">
			<managing-box title="문의자">
				<router-link
					:to="`/register/register-info/${detail.register_id}`"
					class="link"
					target="_blank"
					>{{ detail.nickname }}</router-link
				>
			</managing-box>
		</managing-section>
		<managing-section
			v-if="staticCode === 'CSP_01'"
			:splice="true"
			:column-count="2"
		>
			<managing-box title="브랜드명">
				{{ detail.brand_name }}
			</managing-box>
			<managing-box title="제품명">
				{{ detail.product_name }}
			</managing-box>
		</managing-section>
		<managing-section :splice="true">
			<managing-box title="내용">
				<template v-if="detail.body">
					{{ detail.body }}
				</template>
				<p v-else class="disabled-text">등록된 내용이 없습니다.</p>
			</managing-box>
			<managing-box
				v-if="staticCode !== 'CSP_01'"
				title="제품정보"
				:no-padding="true"
			>
				<table v-if="product" class="req__product-table product">
					<tbody>
						<tr>
							<td rowspan="3" class="product__img-cell">
								<img
									:src="product.productImg"
									class="product__img-cell__img"
								/>
							</td>
							<th>카테고리</th>
							<td>{{ getCategory(product.categoryList[0]) }}</td>
							<template v-if="staticCode === 'CSP_02'">
								<th>용량/가격</th>
								<td>
									{{ product.volume }} / {{ product.price }}
								</td>
							</template>
							<template v-else>
								<th rowspan="2" class="product__factor-cell">
									성분 정보
								</th>
								<td rowspan="2" class="product__factor-cell">
									<div class="product__factor-cell__content">
										<span
											>총
											{{ product.factorCount }} 건</span
										>
										<!--
                                            성분추가기능 기획서에 맞게 구현했으나 운영팀 요청으로 상품상세 링크로 변경함
                                            다시 변결될 수 있어서 주석처리함
                                        -->
										<!-- <button
                                            class="btn"
                                            @click="addFactor"
                                        >추가</button> -->
										<router-link
											:to="`/product/product-inquiry/${product.idProduct}`"
											class="btn"
											target="_blank"
											>추가</router-link
										>
									</div>
								</td>
							</template>
						</tr>
						<tr>
							<th>브랜드</th>
							<td>{{ product.brandTitle }}</td>
							<template v-if="staticCode === 'CSP_02'">
								<th>평점/리뷰</th>
								<td>
									{{ product.ratingAvg }} (리뷰
									{{ product.commentCount }})
								</td>
							</template>
						</tr>
						<tr>
							<th class="product__name-cell">제품명</th>
							<td colspan="3" class="product__name-cell">
								<router-link
									:to="`/product/product-inquiry/${product.idProduct}`"
									class="link"
									target="_blank"
									>({{ product.idProduct }})
									{{ product.productTitle }}</router-link
								>
							</td>
						</tr>
					</tbody>
				</table>
			</managing-box>
			<managing-box
				title="첨부이미지<br>(클릭 시 확대)"
				:horizontal-mode="true"
			>
				<template v-if="imgList.length">
					<img
						v-for="item in imgList"
						:key="item.id"
						:src="item.src"
						class="req__attach-img"
						@click="showOriginImg(item)"
					/>
				</template>
				<p v-else class="disabled-text">첨부된 이미지가 없습니다.</p>
			</managing-box>
		</managing-section>
		<managing-section header="답변 정보" :column-count="2">
			<managing-box title="답변상태">
				<b v-if="detail.state">{{ detail.state }}</b>
				<RadioList
					v-else
					v-model="state"
					:radio-list="stateList"
					:disabled="true"
					:disabled-ids="[null]"
					@input="stateChange"
				/>
			</managing-box>
			<managing-box title="답변일">
				{{ detail.updatedAt }}
			</managing-box>
		</managing-section>
		<managing-section :splice="true">
			<managing-box title="답변내용">
				<input v-model="message" type="text" />
			</managing-box>
		</managing-section>
		<managing-section v-if="staticCode === 'CSP_01'">
			<managing-box title="제품 맵핑">
				<product-searcher ref="productId" @change="productIdChange" />
			</managing-box>
		</managing-section>
		<ManagingSection header="답변 발송">
			<ManagingBox title="발송 방법">
				<b v-if="detail.state">{{ sendWayType }}</b>
				<CheckboxList
					v-else
					v-model="sendWayType"
					:checkboxList="sendWayTypeList"
				/>
			</ManagingBox>
		</ManagingSection>
		<div v-if="!detail.state" class="btn-wrap-main">
			<button class="btn-main" @click="initRes">초기화</button>
			<button
				:disabled="disabledRegister"
				class="btn-main blue"
				@click="update"
			>
				등록
			</button>
		</div>
		<managing-section>
			<managing-box title="메모">
				<memo-box ref-type="cs_product" :ref-id="Number(cspId)" />
			</managing-box>
		</managing-section>
	</article>
</template>
<script>
	import pick from 'lodash/pick';
	import compact from 'lodash/compact';
	import util from '@/util.js';
	import { mapState } from 'vuex';
	import moment from 'moment';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '@/components/RadioList';
	import CheckboxList from '@/components/CheckboxList';
	import ProductSearcher from '@/components/ProductSearcher.vue';
	import MemoBox from '@/components/MemoBox.vue';

	const sendWayTypeList = [
		{ id: 'is_push', value: 'Push(알림)' },
		{ id: 'is_message_box', value: '알림함' },
	];

	export default {
		name: 'ProductReq',
		components: {
			PageHeader,
			ManagingSection,
			ManagingBox,
			RadioList,
			CheckboxList,
			ProductSearcher,
			MemoBox,
		},
		data() {
			return {
				backToList: false,
				staticCode: '',
				title: '',
				cspId: null,
				detail: {},
				imgList: [],
				stateList: [
					{ id: null, value: '대기' },
					{ id: '완료', value: '완료' },
					{ id: '반려', value: '반려' },
				],
				state: null,
				sendWayTypeList,
				sendWayType: sendWayTypeList.map(({ id }) => id),
				message: '',
				productId: null,
				product: null,
			};
		},
		computed: {
			...mapState({
				staticCodes: state =>
					state.filter.staticCodes.filter(
						item => item.parent_code === 'CSP'
					),
				IMAGE_STORAGE_PATH: state => state.env.IMAGE_STORAGE_PATH,
			}),
			defaultMessage() {
				if (!this.state) {
					return '';
				}
				const messageArr = [
					this.staticCode === 'CSP_03' ? '성분이' : '제품이',
					this.state === '완료'
						? this.staticCode === 'CSP_02'
							? '수정'
							: '등록'
						: '반려',
				];
				return `요청하신 ${messageArr.join(' ')}되었습니다.`;
			},
			disabledRegister() {
				return !(!this.detail.state && this.state);
			},
		},
		created() {
			this.setPage();
		},
		mounted() {
			this.setDetailData();
		},
		async beforeRouteLeave(to, from, next) {
			if (!this.backToList || to.name === 'ProductReqList') {
				next();
			} else {
				next({ name: 'ThemeList' });
			}
		},
		methods: {
			showOriginImg(img) {
				util.popupImages([img.src], 500);
			},
			stateChange() {
				this.message = this.defaultMessage;
			},
			setPage() {
				const curCode = this.$route.params.staticCode;
				const idx = this.staticCodes.findIndex(
					item => item.code === curCode
				);
				const codeObj = this.staticCodes[idx > -1 ? idx : 0];
				const code = codeObj.code;
				if (curCode !== code) {
					this.$router.replace({
						path: `/product/req/${code}`,
						query: { ...this.$route.query },
					});
				}
				this.staticCode = code;
				this.title =
					document.title = `${codeObj.name.match(/.{1,2}/g).join(' ')} 상세정보`;
				this.cspId = Number(this.$route.query.cspId);
			},
			deleteImg() {
				if (!confirm('첨부이미지를 삭제하시겠어요?')) return;
			},
			productIdChange({ id }) {
				this.productId = id;
			},
			getCategory({
				firstCategoryText,
				secondCategoryText,
				thirdCategoryText,
			}) {
				return compact([
					firstCategoryText,
					secondCategoryText,
					thirdCategoryText,
				]).join(' > ');
			},
			addFactor() {
				this.$store.commit('modal/toggleModal', {
					id: 'ProductIngredientController',
					params: {
						selectedList: this.product.factorList.map(item => ({
							id: item.factorIdx,
							value: `${item.factorKorean}(${item.factorEnglish})`,
						})),
						register: async (factorList = []) => {
							const details = this.product;
							const params = {
								...pick(details, [
									'colorType',
									'factorsDisplay',
									'fileDir',
									'fileOrgName',
									'fileSaveName',
									'fileSize',
									'fileType',
									'idBrand',
									'idProduct',
									'isDiscontinue',
									'isDisplay',
									'price',
									'productText',
									'productTitle',
									'releaseMonth',
									'releaseYear',
									'volume',
								]),
								brandTypeList: details.storeList.map(
									item => item.idBrandType
								),
								categoryMappings: details.categoryList.map(
									item => ({
										idSecondCategory: item.idSecondCategory,
										idThirdCategory:
											item.idThirdCategory || null,
										isPrimary: item.isPrimary,
									})
								),
								factorList,
								insertIdRegister:
									this.$store.state.login.idRegister,
								keywordList: details.keywordList.map(
									item => item.idKeyword
								),
								primarySecondCategory:
									details.categoryList.find(
										item => item.isPrimary
									).idSecondCategory,
							};
							await this.$axiosAdmin2.post(
								'/api/products',
								params
							);
							this.product.factorCount = factorList.length;
						},
					},
				});
			},
			async setProduct(productId) {
				try {
					this.productId = productId;
					const { data } = await this.$axiosAdmin2.get(
						`/api/products/${productId}`
					);
					const product = (this.product = data.data);
					if (this.staticCode === 'CSP_01') {
						this.$refs.productId.setValue(product.idProduct);
					} else {
						this.product.productImg = `${this.$store.state.env.IMAGE_STORAGE_PATH}${product.fileDir}/${product.fileSaveName}`;
					}
				} catch (err) {
					console.error(err);
				}
			},
			async setDetailData() {
				try {
					const { data } = await this.$axiosSupport.get(
						`/admin/cs/product/${this.cspId}`
					);
					const createdAtRes = data.message_box.created_at;
					const updatedAt = moment(data.cs_product.updated_at);
					this.detail = {
						...data.cs_product,
						createdAtReq: data.cs_product.created_at
							? moment(data.cs_product.created_at).format(
									'YYYY.MM.DD HH:mm:SS'
								)
							: '-',
						nickname: data.register.nickName,
						createdAtRes: createdAtRes
							? moment(createdAtRes).format('YYYY.MM.DD HH:mm:SS')
							: '-',
						updatedAt:
							data.cs_product.state && updatedAt.isValid()
								? updatedAt.format('YYYY.MM.DD HH:mm:SS')
								: '-',
					};
					this.imgList = data.cs_product_attaches.map(item => ({
						id: item.id,
						src: `${this.IMAGE_STORAGE_PATH}${item.path}`,
					}));
					this.state = data.cs_product.state;
					this.message = createdAtRes
						? data.message_box.message
						: this.defaultMessage;
					const productId = data.cs_product.product_id;
					const sendInfo = JSON.parse(data.cs_product.doc)?.send_info;
					if (productId) {
						this.setProduct(productId);
					}

					if (this.detail.state) {
						this.sendWayType = sendInfo
							? `${sendInfo.is_push ? 'Push(알림)' : ''} ${sendInfo.is_message_box ? '알림함' : ''}`.trim() ||
								'안함'
							: '안함';
					}
				} catch (err) {
					console.error(err);
				}
			},
			async update() {
				if (this.state !== '반려' && !this.productId) {
					alert('제품을 맵핑해주세요.');
					this.$refs.productId.$refs.searcher.focus();
					return;
				}
				if (!confirm(`정말 ${this.state}처리 하시겠습니까?`)) return;
				const params = {
					state: this.state,
					product_id: this.productId,
					message: this.message,
				};
				if (this.sendWayType.length) {
					this.sendWayType.forEach(item => {
						params[item] = true;
					});
				}
				await this.$axiosSupport.put(
					`/admin/cs/product/${this.cspId}`,
					params
				);
				this.backToList = true;
				this.$router.go(-1);
			},
			initRes() {
				if (!confirm('답변 내용을 전체 초기화 하시겠어요?')) return;
				this.state = this.detail.state;
				this.message = this.defaultMessage;
			},
		},
	};
</script>
<style lang="scss" scoped>
	.product {
		th,
		td {
			border: solid 1px #dfe6ee;
			padding: 8px;
			font-size: 0.875rem;
		}

		th {
			background: #f4f7fa;
			font-weight: bold;
			color: #657088;
		}

		tr:first-child {
			th,
			td {
				border-top: 0;
			}

			td:first-of-type {
				border-left: 0;
				padding: 0;
				width: 100px;
			}
		}

		td:last-of-type {
			border-right: 0;
		}

		.product__img-cell,
		.product__name-cell {
			border-bottom: 0;
		}

		.product__factor-cell {
			vertical-align: middle;
		}
	}

	.product__img-cell__img {
		display: block;
		max-width: 100px;
		max-height: 100px;
	}

	.product__factor-cell__content {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.req__attach-img {
		cursor: pointer;
		display: block;
		margin-right: 12px;
		max-width: 300px;
		max-height: 300px;
	}
</style>
